module.exports = __webpack_public_path__ + "img/product_category_preview_image-7.344f358.webp";